import React from 'react';
import * as utils from '../../common/Utils.js';

const DraftBoard = ({ computedDraftPicks, onPickClick }) => {
  if (!computedDraftPicks || computedDraftPicks.length === 0) {
    return <p className="text-align-center">No draft picks to display.</p>;
  }

  return (
    <div className="drafted-players-container">
      {computedDraftPicks.map((pick) => {
        const team = pick.team;
        if (!team) return null;

        return (
          <div
            key={pick.playerID && pick.playerID !== '' ? pick.playerID : `pick-${pick.number}`}
            id={pick.currentPick ? 'current-pick' : undefined}
            onClick={() => onPickClick && onPickClick(team.id)}
            className={`drafted-player-box ${pick.playerID && pick.playerID !== '' ? 'pick-is-in' : pick.onClock ? 'on-the-clock' : ''} ${team.id}`}
          >
            <div className="draft-box">
              <p>{pick.number}</p>
              <p>{team.name}</p>
            </div>
            <p className="draftPlayerName">
              {pick.playerID && pick.playerID !== '' && pick.player
                ? utils.displayPlayerName(pick.player)
                : utils.formatDraftTime(pick.time)}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default DraftBoard;
